import api from "!../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../string-replace-loader/index.js??ruleSet[1].rules[4].rules[2]!../css-loader/dist/cjs.js!../postcss-loader/dist/cjs.js??ruleSet[1].rules[4].rules[4]!./rrui.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};